<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import apiProxy from './apis/api-proxy-inst';
import authInfoMgmt from './auth-info-mgmt-inst';

export default {
  name: 'App',
  components: {},
  data() {
    return {};
  },
  mounted() {
    authInfoMgmt.init().then(() => {
      if (authInfoMgmt.isSignedIn()) {
        this.$router.push({ name: this.$router.name });
      } else {
        this.$router.push({ name: 'Login' });
      }
      apiProxy.listenAuthException(this.onAuthException);
      apiProxy.listenUnknownException(this.UnknownException);
    });
  },
  beforeDestroy() {
    apiProxy.stopAuthException(this.onAuthException);
    apiProxy.stopUnknownException(this.UnknownException);
  },
  methods: {
    onAuthException() {
      let message = 'Unknown';
      authInfoMgmt.signOut();
      this.$router.push({ name: 'Login' });
      message = this.$t('certification_expires');
      this.$message({
        message,
        type: 'error',
        duration: 5000,
        offset: 80
      });
    },

    UnknownException(e) {
      console.log('UnknownException e:', e);
      if (e.code === 3 || e.code === 1002 || e.code === 1003 || e.code === 1004) {
        console.log('inner page show error message');
        return;
      }
      let message = 'Unknown';
      if (e.code !== 10101) {
        switch (e.code) {
          case 10005:
            message = this.$t('user_not_active');
            break;
          case 10006:
            message = this.$t('user_password_error');
            break;
          case 10007:
            message = this.$t('user_not_exist');
            break;
          case 50999:
            message = e.message;
            break;
          case 12000:
            message = e.message;
            break;
          case 10098:
            message = this.$t('error_tip_10098');
            break;
        }
      }
      this.$message({
        message: message,
        duration: 3000
      });
    }
  }
};
</script>

<style lang="scss">
@import '~../../common/style/app';
@import '~../../common/style/elementui';
@import '~../../common/style/common-icon';
#app {
  @include app;
}
.el-table th>.cell,
.el-form-item__label {
  word-break: keep-all;
}
.el-form--label-left .el-form-item__label {
  display: flex;
  align-items: center;
  line-height: 1;
  height: 40px;
}
</style>
